module.exports = __webpack_public_path__ + "img/skypets-2.a2d7b013.webp";